<div class="pb-20">
  <rk-mobile-close-button (click)="exitPanel()"></rk-mobile-close-button>
  <mat-calendar
    [startAt]="selected"
    [minDate]="data.minDate"
    [maxDate]="data.maxDate"
    [(selected)]="selected"
    [headerComponent]="headerComponent"
  ></mat-calendar>
</div>
<rk-footer-actions
  [submitText]="'GLOBAL.SELECT' | translate"
  (submitted)="onSubmit()"
  (cancelled)="exitPanel()"
></rk-footer-actions>
